
import Vue from 'vue';
import { mapMutations } from 'vuex';

export default Vue.extend({
  name: 'UserMixin',

  computed:{
    // 給歸戶使用的id
    uuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        // eslint-disable-next-line no-bitwise
        const r = (Math.random() * 16) | 0;
        // eslint-disable-next-line no-bitwise
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
  },

  methods: {
    // 未登入 || 登出
    signOut() {
      this.apiStart();
      this.$router.push({
        name: 'home',
      });
      const stateUserData = {
        isStatus: false,
        isLogin: false,
        chanExpireDate: '',
        realName: '',
        userName: null,
      };
      this.changeLogin(stateUserData);
      document.cookie = 'sessionId=;expires=;';
      this.apiStop();
    },
    // 刪除 戶役政 暫存資料
    async $deleteCache(data) {
      console.log('資料砍掉', data);
      const url = '/GovEReceipt/CacheManagerService/Delete';
      await this.axiosServiceSend(data, url, 'post', 'deleteCache');
    },
    // 清除 cookie
    $clearCookie(name, nameVal) {
      // 刪除 cookie
      const exp = new Date();
      exp.setTime(exp.getTime() - 1);
      document.cookie = `${name}=${nameVal};expires=${exp.toGMTString()}`;
    },

    // 取得 token UUID
    $getUUID(name) {
      console.log('getUUID name=', name);
      // const name = 'sessionUUId';
      const arry = document.cookie.split(';');
      for (let i = 0; i < arry.length; i += 1) {
        const temp = arry[i].trim().split('=');
        if(temp === '' || temp === null || temp === undefined || temp[0] === ''){
          return '';
        }
        if (temp.indexOf(name) === 0) {
          return temp[temp.indexOf(name) + 1];
        }
      }
      return '';
    },

    // 更新 token
    $sessionChangeTime(value, sessionId, refrestToken) {
      // sessionExpires毫秒數
      const sessionExpires = new Date(value).getTime();

      // sessionExpires毫秒數 扣掉 兩天 毫秒數
      const changeSessionExpires = sessionExpires - 172800000;

      const todayTime = new Date().getTime(); // + 604800000

      // 如果 當下登入毫秒數 大於等於 sessionExpireS前兩天毫秒數
      if (todayTime >= changeSessionExpires) {
        this.axios({
          url: '/GovEReceipt/UserLoginService/RefreshAccessToken',
          method: 'post',
          data: {
            sessionId,
            refrestToken,
          },
        })
          .then((res) => {
            console.log(res);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        console.log('我沒超過不做事');
      }
    },

    // 使用者登入
    $userLogin() {
      this.apiStart();
      // const nowUrl = window.location.href.split("/T")[0];
      console.log('process.env.NODE_ENV' , process.env)
      const tPassUrl = process.env.VUE_APP_GOTPASS;
      const receiptUrl =  process.env.VUE_APP_URL;
      this.$nextTick(() => {
        const clientId =  process.env.VUE_APP_CLIENT_ID;
        const redirectUrl = `${receiptUrl}/TPGovEReceipt/holdReceipt`;
        const scope =
          'uuid%20city_internet_uid%20account%20member_type%20formatted_name%20real_name%20id_no%20email%20phone_no%20birthday';
        // const scope =
        //   'uuid%20account%20email%20phone_no%20member_type%20formatted_name real_name%20id_no%20birthday';
        const authUrl = `${tPassUrl}/oauth2/authorize?response_type=code&client_id=${clientId}&scope=${scope}`;
        // const authUrl = `${tPassUrl}/oauth/authorize?response_type=code&client_id=${clientId}&redirectUri=${redirectUrl}&scope=${scope}`;
        window.location.href = authUrl;
        this.apiStop();
      });
    },

    // 登出
    $signOutClearCookie() {
      // this.getCookieRun();
      this.getCookieRunVal = this.$getUUID('sessionId');
      console.log('取cookie:', this.getCookieRunVal);
      this.$router.push({
        name: 'home',
      });
      const stateUserData = {
        isStatus: false,
        isLogin: false,
        chanExpireDate: '',
        realName: '',
        userName: null,
      };
      this.changeLogin(stateUserData);
      this.$nextTick(() => {
        this.axios({
          url: '/GovEReceipt/CacheManagerService/Delete',
          method: 'post',
          data: {
            sessionId: this.getCookieRunVal,
          },
        })
          .then((res) => {
            console.log(res);
            // if (res.data.object === true) {
              console.log('我要清除cookie');
              this.$clearCookie('sessionId', this.getCookieRunVal)
              // document.cookie = 'sessionId=;expires=;';
            // }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
      ...mapMutations({
        apiStart: 'api/start',
        apiStop: 'api/stop',
      }),
    },
});
